module.exports = __webpack_public_path__ + "static/media/display_black.445a31a0.png";